import type { StatusVariant } from '@/ui/StatusBadge';

import type { StatusMedicao } from './contrato';

/**
 * Apresentação compartilhada entre a listagem e o detalhe do Financeiro —
 * como o estágio de uma medição vira selo, e como a competência vira texto.
 *
 * `StatusBadge` só aceita o conjunto fechado de selos de `@/ui/StatusBadge`,
 * pensado para as entidades que já existem no sistema. Nenhum bate
 * literalmente com o estágio de uma medição, então este mapa escolhe o selo
 * de tom mais próximo — sucesso/atenção/neutro — e sempre passa o rótulo em
 * português por fora, explícito.
 */
export const SELO_DA_MEDICAO: Record<StatusMedicao, { variante: StatusVariant; rotulo: string }> = {
  em_apuracao: { variante: 'em_execucao', rotulo: 'Em apuração' },
  aguardando_ateste: { variante: 'pendente', rotulo: 'Aguardando ateste' },
  pago: { variante: 'pago', rotulo: 'Pago' },
};

export const OPCOES_DE_STATUS_DA_MEDICAO = [
  { value: 'em_apuracao', label: 'Em apuração' },
  { value: 'aguardando_ateste', label: 'Aguardando ateste' },
  { value: 'pago', label: 'Pago' },
];

/** "2026-07-01" -> "07/2026". String, para não depender de fuso na conversão. */
export function formatarCompetencia(competencia: string): string {
  const [ano, mes] = competencia.split('-');
  return `${mes}/${ano}`;
}

const MESES_POR_EXTENSO = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

/** "2026-07-01" -> "Julho de 2026". Para o título do demonstrativo. */
export function formatarCompetenciaPorExtenso(competencia: string): string {
  const [ano, mes] = competencia.split('-');
  const nomeDoMes = MESES_POR_EXTENSO[Number(mes) - 1] ?? mes ?? '';
  return `${nomeDoMes.charAt(0).toUpperCase()}${nomeDoMes.slice(1)} de ${ano}`;
}
